import { Authorization } from "@wingspanhq/wingspan-api-sdk";
import {
  getAdminSessionToken,
  getRequestingTokenFromURL,
  getRequestingUserSessionToken,
  getWingspanAdminSessionToken
} from "../../services/sessionStorage";

class AccountAccessService {
  getImpersonationState() {
    const adminToken = getAdminSessionToken();
    const requestingUserTokenFromURL = getRequestingTokenFromURL();
    const requestingUserSession = getRequestingUserSessionToken();
    const wingspanAdminToken = getWingspanAdminSessionToken();

    const isImpersonatedByWingspanAdmin =
      adminToken && wingspanAdminToken
        ? adminToken === wingspanAdminToken
        : false;

    const isImpersonated =
      !!adminToken || !!requestingUserTokenFromURL || !!requestingUserSession;

    return { isImpersonated, isImpersonatedByWingspanAdmin };
  }

  resolveAccess(accountId: string, allGrants: Authorization[]) {
    const { isImpersonated, isImpersonatedByWingspanAdmin } =
      this.getImpersonationState();

    const grantsForAccount = accountId
      ? allGrants.filter(grant => grant.grantorAccountId === accountId)
      : [];

    const hasGrants = grantsForAccount.length > 0;

    const scopes = Array.from(
      new Set(grantsForAccount.flatMap(grant => grant.scopes ?? []))
    );

    const hasFullAccess = isImpersonated || !hasGrants || scopes.includes("*");

    return {
      scopes,
      hasFullAccess,
      hasScope: (scope: string) =>
        hasFullAccess || scopes.some(item => item === scope),
      isImpersonated,
      isImpersonatedByWingspanAdmin
    };
  }
}

export const accountAccessService = new AccountAccessService();
